import { useRemoveUserFromGroup } from '../../UserDetails/hooks/useRemoveUserFromGroup';
import { UsersApi } from '../../../api-client';
import { useContext } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { getApiConfiguration } from '../../../common';
import { useParams } from 'react-router-dom';
import { useGetUserGroupLinks } from './useGetUserGroupLinks';
import { useQueryClient } from 'react-query';

type UseRemoveUserFromGroupFacade = (
  groupId: string,
  closeGroupUserDeleteModal: () => void,
) => {
  isRemoving: boolean;
  handleRemoveUserFromGroup: <T>(original: T) => void;
};

export const useRemoveUserFromGroupFacade: UseRemoveUserFromGroupFacade = (
  groupId,
  closeGroupUserDeleteModal,
) => {
  const { id } = useParams<{ id: string }>();
  const { showNotification } = useContext(NotificationsContext);
  const usersApi = new UsersApi(getApiConfiguration());
  const queryClient = useQueryClient();

  const { mutate: removeUser, isLoading: isRemoving } = useRemoveUserFromGroup(usersApi);

  const { mutate: getGroupLinks, isLoading: isReceiving } = useGetUserGroupLinks(usersApi);

  const onSuccess = () => {
    closeGroupUserDeleteModal();
    queryClient.invalidateQueries(`group-${groupId}-users`).then();
    showNotification('User successfully removed!');
  };

  const onError = () => showNotification('An error occurred!');

  const handleRemoveUserFromGroup = async <T,>(original: T) => {
    // @ts-ignore
    getGroupLinks(original?.id, {
      onSuccess: ({ data: links }) => {
        const documentId = links?.find(
          ({ userGroupDocumentId }) => userGroupDocumentId === id,
        )?.documentId;

        removeUser(
          {
            // @ts-ignore
            userId: original?.id as string,
            groupId: documentId as string,
          },
          {
            onSuccess,
            onError,
          },
        );
      },
    });
  };

  return {
    handleRemoveUserFromGroup,
    isRemoving: isRemoving || isReceiving,
  };
};
